import { motion, useReducedMotion } from 'framer-motion';
import { PROCESS } from '../../data/site';
import Container from '../ui/Container';
import Reveal, { EASE, staggerChild, staggerParent } from '../ui/Reveal';

function ProcessSteps() {
  const reduce = useReducedMotion();

  return (
    <section className="bg-surface py-20 sm:py-28">
      <Container>
        <Reveal from="left" className="max-w-2xl">
          <h2 className="text-balance text-[1.85rem] font-bold leading-[1.2] tracking-[-0.025em] sm:text-4xl lg:text-[2.75rem]">
            이렇게 진행합니다
          </h2>
          <p className="mt-4 text-base leading-[1.75] text-ink-soft sm:text-lg">
            처음 상담부터 배포 후 운영까지 네 단계로 나눠 진행하고, 단계마다 결과물을 확인한 뒤 다음으로 넘어갑니다.
          </p>
        </Reveal>

        <motion.ol
          className="relative mt-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-8"
          variants={staggerParent(0.14, 0.2)}
          initial={reduce ? false : 'hidden'}
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div aria-hidden="true" className="absolute left-0 right-0 top-7 hidden h-px bg-line lg:block">
            <motion.div
              className="bg-brand-gradient h-full w-full origin-left"
              initial={reduce ? false : { scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 1.4, ease: EASE, delay: 0.2 }}
            />
          </div>

          {PROCESS.map((step, index) => (
            <motion.li key={step.title} variants={staggerChild(0, -40)} className="group relative flex gap-5 lg:block">
              <span className="bg-brand-gradient relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl text-lg font-bold text-white shadow-accent transition-transform duration-300 group-hover:-translate-y-1 group-hover:rotate-[-6deg]">
                {index + 1}
              </span>
              <div className="lg:mt-7">
                <h3 className="text-lg font-bold tracking-tight sm:text-xl">{step.title}</h3>
                <p className="mt-2 text-[15px] leading-[1.75] text-ink-soft">{step.description}</p>
              </div>
            </motion.li>
          ))}
        </motion.ol>
      </Container>
    </section>
  );
}

export default ProcessSteps;
